import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from '@mui/material';
import { useCommonStyles } from 'components/TeamOverview/BillingSection/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React from 'react';
import { useGroupViewStyles } from 'components/TeamOverview/BillingSection/views/styles';
import { BLOCKS_V2_URL } from 'constants/urls';

export const GroupView = ({ RowComponent, orders, project }) => {
  const { classes: groupViewClasses } = useGroupViewStyles();
  const { classes: commonClasses } = useCommonStyles();
  const classes = { ...groupViewClasses, ...commonClasses };

  return (
    <Accordion className={classes.accordion} defaultExpanded>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        slots={{ expandIcon: ExpandMoreIcon }}
        className={classes.accordionSummary}
      >
        <Box
          className={`${classes.link} ${classes.groupHeader}`}
          onClick={() =>
            window.open(`${BLOCKS_V2_URL}#project=${project.name}`, '_blank')
          }
        >
          {project.name}
        </Box>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetails}>
        {orders.map((row) => (
          <RowComponent key={row.orderUUID} {...row} />
        ))}
      </AccordionDetails>
    </Accordion>
  );
};
